import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('MessageSpacer', ((theme) => ({
  root: {
    paddingTop: theme.spacing(1),
  },
})));

const MessageSpacer = () => {
  const classes = useStyles();
  return (
    <div
      className={classes.root}
    />
  );
};

export default MessageSpacer;
